import { useDebriefV2State } from '../../shared/context/DebriefV2StateContext';
import type { DescribeAction, DescribeState } from '../types/describe.types';
import type { Dispatch } from 'react';

interface DescribeStateContextValue {
  state: DescribeState;
  dispatch: Dispatch<DescribeAction>;
}

export function useDescribeState(): DescribeStateContextValue {
  return useDebriefV2State().describe;
}
